import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import {indigo400} from 'material-ui/styles/colors';
import Title from '../components/Title';
import Benefits from '../components/Benefits';
import PlaceCard from '../components/places/PlaceCard';
import data from '../requests/places';
import TransitionGroup from 'react-transition-group/TransitionGroup';

export default class Home extends React.Component
{

  constructor( props )
  {
       super( props )

      this.state = { places: data.places }
      this.hidePlace = this.hidePlace.bind( this )
      // EJEMPLO DE : state numero : 7

      /*

          setInterval( ( ) =>
          {
               this.setState({ numero : this.state.numero + 1 })
          }, 1000 )

      */
  }

  places( )
  {
    return this.state.places.map( ( place, index )=>
    {
      return( <PlaceCard onRemove={ this.hidePlace } place={ place } index={ index } /> )
     })
  }

  hidePlace( place )
  {
    this.setState({ places: this.state.places.filter( el => el != place ) })
  }

  render( )
  {
    return(
      <section>
        <div className="Header-background">
          <div style={{ "width":"80%", "margin":"0 auto" }}>
            <div className="Header-main">
              <Title></Title>

              <RaisedButton label="Create An Count" secondary={ true }  onClick={ ( )=> { console.log( "Hello" ) } } />

              <img className="Header-illustration" src={ process.env.PUBLIC_URL + '/img/Places.png' } />

            </div>
            <div>
              <Benefits/>
            </div>
          </div>

        </div>
        <div style={{ 'backgroundColor': '#222', 'padding': '50px', color: 'white' }}>
          <h3 style={{ 'fontSize': '24px' }}>Popular Sites</h3>
          <TransitionGroup className="row">
            { this.places( ) }
          </TransitionGroup>
        </div>
      </section>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/Home.js